export default "__VITE_ASSET__BUa1ymvh__"